import { render, staticRenderFns } from "./MultiSelectCustom.vue?vue&type=template&id=2b1a08f7"
import script from "./MultiSelectCustom.vue?vue&type=script&lang=js"
export * from "./MultiSelectCustom.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectCustom.vue?vue&type=style&index=0&id=2b1a08f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports